const EXPLICIT_SCHEME_PATTERN = /^([a-z][a-z0-9+.-]*):/i;
const PROTOCOL_RELATIVE_PATTERN = /^\/\//;

const looksLikePublicHostname = (value: string): boolean => {
  const authorityCandidate = value.split(/[/?#]/, 1)[0];
  const hostnameWithoutPort = authorityCandidate.replace(/:\d+$/, "");
  return hostnameWithoutPort.includes(".");
};

/**
 * Makes a customer-entered website address ready for submission.
 *
 * This is deliberately a usability helper, not a security boundary. It adds
 * HTTPS only when a scheme is missing and the input resembles a public
 * hostname. The API remains authoritative for URL parsing, DNS resolution,
 * supported ports and public-network enforcement.
 */
export const normalizeWebsiteUrlInput = (rawValue: string): string => {
  const trimmedValue = rawValue.trim();
  if (!trimmedValue) return "";

  if (PROTOCOL_RELATIVE_PATTERN.test(trimmedValue)) {
    return `https:${trimmedValue}`;
  }

  const explicitScheme = trimmedValue.match(EXPLICIT_SCHEME_PATTERN)?.[1];
  const explicitSchemeIsNotAHostnameWithPort =
    explicitScheme !== undefined && !explicitScheme.includes(".");
  if (explicitSchemeIsNotAHostnameWithPort) return trimmedValue;

  return looksLikePublicHostname(trimmedValue)
    ? `https://${trimmedValue}`
    : trimmedValue;
};
